<button class="help-button" (click)="onHelpButtonClicked()" pTooltip="Show help information" tooltipPosition="left">
  <i class="fa-solid fa-circle-question fa-2xl cursor-pointer"></i>
</button>
